export default __webpack_public_path__ + "static/media/logo-dark.11cdd831.png";